import type { VoidFunctionComponent } from 'react';
import { BadgeColors, BadgeSizes, IconText, TooltipBadge, icons } from '../../../../generic';

const MAX_LENGTH = 50;
export const OriginOrganizationNameBadge: VoidFunctionComponent<{
  originOrganizationName: string | undefined,
}> = ({ originOrganizationName }) => {
  if (!originOrganizationName) {
    return null;
  }

  let truncatedName = originOrganizationName;
  if (truncatedName.length > MAX_LENGTH) {
    truncatedName = `${truncatedName.substring(0, MAX_LENGTH)}...`;
  }

  return (
    <TooltipBadge
      id="origin-organization-name"
      tooltip={<IconText icon={icons.circleInfo} text={originOrganizationName} />}
      color={BadgeColors.LightGray}
      size={BadgeSizes.Micro}
    >
      {truncatedName}
    </TooltipBadge>
  );
};
